module.exports = __webpack_public_path__ + "static/anana-vestige-journal-video-d1507e450b4302a2c0670cc2454d9f76.mp4";